var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.title)?_c('div',{class:['gray-panel', _vm.wrapperClass]},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"content bg-white"},[_vm._t("default"),_vm._v(" "+_vm._s(_vm.content)+" ")],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }